module.exports = __webpack_public_path__ + "img/ThumbUp.5cab0500.svg";